import { useNavigate } from "react-router-dom";
import { EventSchedule } from "shared/ui/event-schedule";
import { Button } from "shared/ui/button";
import { EVENT_PROGRAM_ROUTE } from "shared/config/routes";
import { schedule } from "../lib/scheduleData";
import styles from "./EventScheduleSection.module.scss";

export const EventScheduleSection = ({}) => {
  const navigate = useNavigate();

  const handleProgramClick = () => {
    navigate(EVENT_PROGRAM_ROUTE);
  };

  return (
    <div className={styles.scheduleWrapper}>
      <p className={styles.scheduleWrapper__title}>Программа</p>
      <div>
        <EventSchedule items={schedule} />
        <div className={styles.scheduleWrapper__buttonBlock}>
          <div className={styles.scheduleWrapper__button}>
            <Button variant="primary" size="large" onClick={handleProgramClick}>
              Показать полностью
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
